// Figures.js
import React, { useEffect, useState } from "react";
import { Element } from "react-scroll";
import "./Figures.css";

function Figures() {
  const [showFigures, setShowFigures] = useState(false);

  useEffect(() => {
    const section = document.getElementById("key-figures");
    if (!section) return;

    const onScroll = () => {
      const top = section.getBoundingClientRect().top;
      const height = window.innerHeight;

      if (top < height * 0.75) {
        setShowFigures(true);
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="figures-wrapper" aria-labelledby="figures-heading">
      {/* Section Heading */}
      <header className="section-title">
        <h2 id="figures-heading" className="section-heading">
          Key Operating Figures
        </h2>
      </header>

      {/* Figures Grid */}
      <Element
        id="key-figures"
        name="key-figures"
        className={`achievements ${showFigures ? "show" : ""}`}
      >
        <div className="achievement-card">
          <h3 className="achievement-title">Revenue</h3>
          <p className="achievement-number">₹80L</p>
        </div>

        <div className="achievement-card">
          <h3 className="achievement-title">Order Book</h3>
          <p className="achievement-number">₹95L</p>
        </div>

        <div className="achievement-card">
          <h3 className="achievement-title">Operating Income</h3>
          <p className="achievement-number">₹10L</p>
        </div>

        <div className="achievement-card">
          <h3 className="achievement-title">Net Income</h3>
          <p className="achievement-number">₹50L</p>
        </div>
      </Element>
    </section>
  );
}

export default Figures;
